<div class="material-input has-feedback {{ kind }}" [class.inline]="inline">
    <div [class.errored]="errored">
        <div class="addon prefix" *ngIf="prefix" [innerHTML]="prefix"></div>
        <div class="input">
            <!-- INPUT -->
            <ng-content></ng-content>
            <!-- LABEL -->
           <label *ngIf="label">{{ label }} <span *ngIf="required" class="text-danger">*</span></label>
            <div class="addon suffix" *ngIf="suffix" [innerHTML]="suffix"></div>
            <span
                class="input-icon"
                *ngIf="icon || (errored && !inline)"
                (click)="iconClick()"
                [class.can-click]="onIconClick.observers.length > 0"
            >
                <i [ngClass]="errored ? 'fa fa-exclamation-circle' : icon"></i>
            </span>
        </div>
    </div>

    @if (errored) {
        <small class="supporting-label text-feedback-error">
            {{ getError() }}

            <!-- NUM CARACTERES -->
            <small
                *ngIf="input.hasError('minlength') || input.hasError('maxlength')"
                class="pull-right text-muted"
            >
                {{
                    input.value.length +
                    "/" +
                    (this.input.errors['minlength']
                        ? this.input.errors['minlength'].requiredLength
                        : this.input.errors['maxlength'].requiredLength)
                }}
            </small>
        </small>
    } @else if (helperText) {
        <small class="supporting-label text-muted">
            {{ helperText }}
        </small>
    }
    <!-- ERRO -->
</div>
